import React from "react";

const InformationIcon = ({ className = "", size = "24", active = false, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M12 2.5C6.50742 2.5 2 7.00742 2 12.5C2 17.9926 6.50742 22.5 12 22.5C17.4926 22.5 22 17.9926 22 12.5C22 7.00742 17.4926 2.5 12 2.5ZM13.1719 17.1875C13.1719 17.8335 12.646 18.3594 12 18.3594C11.354 18.3594 10.8281 17.8335 10.8281 17.1875V11.3281C10.8281 10.6821 11.354 10.1562 12 10.1562C12.646 10.1562 13.1719 10.6821 13.1719 11.3281V17.1875ZM12 8.98438C11.354 8.98438 10.8281 8.45852 10.8281 7.8125C10.8281 7.16648 11.354 6.64062 12 6.64062C12.646 6.64062 13.1719 7.16648 13.1719 7.8125C13.1719 8.45852 12.646 8.98438 12 8.98438Z"
        fill={active ? "#00C2FF" : "#01BBFE"}
      />
    </svg>
  );
};

export default InformationIcon; 